import React, { useState, PropsWithChildren } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { DATE_FORMAT } from '../../../utils/constants';
import ButtonComponent from '../forms/Button/ButtonComponent';
import { GridCellProps } from '@progress/kendo-react-grid';
import DisplayLocation from '../DisplayLocation';
import DatePickerInputComponent from '../forms/DatePickerInput/DatePickerInputComponent';

export const DateCell = (props) => {
  const { dataItem } = props;
  const { field } = props;
  const value = dataItem[field];
  const date = value ? `${moment(value).format(DATE_FORMAT)} ` : '';
  return <td>{date}</td>;
};
DateCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
};

export const LocationCell = (props: PropsWithChildren<GridCellProps>): JSX.Element => {
  const { dataItem } = props;
  const { field } = props;
  const value = _.get(dataItem, field);

  return (
    <td style={{ height: '100%' }}>
      <DisplayLocation
        chamber={value.warehouseChamber.number}
        column={value.column}
        letter={value.letter}
        level={value.level}
      />
    </td>
  );
};

export const CreatedOnCell = (props) => {
  const { dataItem } = props;
  const { field } = props;
  const value = dataItem[field];
  const createdOn = value ? `${moment(value).format(DATE_FORMAT)} ` : '';
  return <td>{createdOn}</td>;
};
CreatedOnCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
};

export const InputCell = (props, onInputChange) => {
  const { dataItem, field } = props;
  const [value, setValue] = useState(dataItem[field] || '');

  const onChange = (e) => {
    setValue(e.target.value);
    onInputChange(dataItem, e);
  };

  return (
    <td>
      <input type="text" onChange={onChange} value={value} />
    </td>
  );
};
InputCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
};

export const ActionCell = (props, onClick, title) => {
  return (
    <td>
      <ButtonComponent onClick={() => onClick(props)} title={title} />
    </td>
  );
};

export const DatePickerCell = ({ value, onChange, ...rest }) => {
  const dateVal = value ? new Date(value) : '';
  return (
    <DatePickerInputComponent onChange={onChange} value={dateVal} defaultValue={dateVal} {...rest} height={25} />
  );
};
DatePickerCell.propTypes = {
  onChange: PropTypes.func.isRequired,
};
